<div class="lg-container">
  <label class="lg-label">{{ label }}</label>
  <input *ngIf="!textarea" [formControl]="control"  matInput class="input form-control" placeholder="{{ label }}">
  <textarea *ngIf="textarea" [formControl]="control" class="input fix-width"></textarea>

  <div *ngIf="control.invalid && (control.touched)" class="errors-wrapper">
    <span class="text-danger small" translate>{{getErrorKey()}}</span>
  </div>

</div>
